module.exports = __webpack_public_path__ + "img/product_92.d3785b1.webp";